export function Pagination({
  pagination,
  onChange,
}: {
  pagination: { page: number; totalPages: number; limit: number }
  onChange: (page: number, limit: number) => void
}) {
  return (
    <tfoot>
      <tr>
        <td colSpan={10} style={{ textAlign: "center" }}>
          <button
            type="button"
            onClick={() => onChange(pagination.page - 1, pagination.limit)}
            disabled={pagination.page === 1}
            style={{
              padding: "0.5rem 1rem",
              background: pagination.page === 1 ? "none" : "linear-gradient(135deg, #6366f1 0%, #8b5cf6 100%)",
              border: "none",
              borderRadius: "8px",
              color: pagination.page === 1 ? "#94a3b8" : "white",
              fontSize: "0.875rem",
              fontWeight: 500,
              cursor: pagination.page === 1 ? "not-allowed" : "pointer",
              margin: "1rem",
            }}
          >
            Previous
          </button>
          <span>
            Page {pagination.page} of {pagination.totalPages}
          </span>
          <select
            value={pagination.limit}
            onChange={(e) => onChange(1, Number(e.target.value))}
            style={{
              padding: "0.5rem",
              border: "1px solid rgba(255, 255, 255, 0.1)",
              borderRadius: "8px",
              background: "rgba(255, 255, 255, 0.05)",
              color: "#e2e8f0",
              fontSize: "0.875rem",
              margin: "1rem",
            }}
          >
            <option value={10}>10</option>
            <option value={20}>20</option>
            <option value={50}>50</option>
            <option value={100}>100</option>
          </select>
          <button
            type="button"
            onClick={() => onChange(pagination.page + 1, pagination.limit)}
            disabled={pagination.page === pagination.totalPages}
            style={{
              padding: "0.5rem 1rem",
              background:
                pagination.page === pagination.totalPages
                  ? "none"
                  : "linear-gradient(135deg, #6366f1 0%, #8b5cf6 100%)",
              border: "none",
              borderRadius: "8px",
              color: pagination.page === pagination.totalPages ? "#94a3b8" : "white",
              fontSize: "0.875rem",
              fontWeight: 500,
              cursor: pagination.page === pagination.totalPages ? "not-allowed" : "pointer",
            }}
          >
            Next
          </button>
        </td>
      </tr>
    </tfoot>
  )
}
